import './GrandPageAnimatedSections.css'
import GrandCoursesList from '../GrandCoursesList/GrandCoursesList'
import GrandInstitutional from '../GrandInstitutional/GrandInstitutional'
import GranDLogo from '../../../assets/grand/GRAN-D-elementos-01.svg'

export default function GrandPageAnimatedSections() {


    return (
        <section className='GrandPageAnimatedSections-main-container'>
            <div className='GrandPageAnimatedSection-button-cta-container'>
                <a className='GrandPageAnimatedSection-button-cta' href='#grandes-cursos'>Explorar</a>
            </div>
            <FirstSection />
            <SecondSection />
        </section>
    )
}

const FirstSection = () => {

    return (
        <div className='GrandPageHero-first-container' >


            <div className='GrandPageHero-first-relative-wrapper' >

                <div className='GrandPageHero-first-relative-sky' />
                {/* <div  className='GrandPageHero-first-relative-cow' /> */}

                <div className='GrandPageHero-first-relative-grass' />
                <div className='GrandPage-first-text-wrapper'>
                    <h1 className='GrandPage-first--title'>Grandes Animales</h1>
                    {/* <p className='GrandPage--subtitle' >FORMACIÓN VETERINARIA DE EXCELENCIA EN GRANDES ANIMALES</p> */}
                    <p className='GrandPage--subtitle' >Formación veterinaria de excelencia en Grandes Animales</p>
                    <img src={GranDLogo} alt='Logo de GranD' className='GrandPageHero-logo-image' />

                </div>

            </div>

        </div>
    )
}

const SecondSection = () => {


    return (
        <div className='GrandPageHero-second-container'>
            <GrandInstitutional />
            <GrandCoursesList />
        </div>
    )
}